// extracted by css-extract-rspack-plugin
export default {"Container":"BXrp7","HeaderContainer":"PF24K","HeaderName":"MZXlv"};